export var colors = {
  primary: "#24AEC3",
  success: "#59B63D",
  danger: "#CC1D14",
  black: "#000000",
  white: "#ffffff"
};